
import Vue from 'vue';
import CheckboxInput from '@shared/components/CheckboxInput.vue';
import TextArea from '@shared/components/TextArea.vue';

export default Vue.extend({
  name: 'StepThree',
  components: {
    CheckboxInput,
    TextArea,
  },
  props: {
    props: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {
        userDescription: '',
      },
    };
  },
  mounted() {
    this.form = this.props;
  },
  methods: {
    previous(): void {
      this.$emit('previous', this.form);
    },
    send(): void {
      this.$emit('send', this.form);
    },
  },
});
